<template>
  <ShopCart :config="config" />
</template>

<script>
import ShopCart from "../../components/ShopCart/ShopCart.vue";

export default {
  name: "app",
  components: {
    ShopCart
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
